import React, { useEffect } from "react"
import BikeLabelOrderLayout from "./Partials/BikeLabelOrderLayout"
import BikeLabelOrderStep from "./Partials/bikeLabelOrderStep/BikeLabelOrderStep"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { getLabelOrderProductThunk } from "./slice/bikeLabelOrderThunks"
import { activeOrderSelector } from "./slice/bikeLabelOrderSelectors"

const BikeLabelOrder: React.FC = () => {
	const activeOrder = useAppSelector(activeOrderSelector)
	const dispatch = useAppDispatch()
	useEffect(() => {
		if (!activeOrder) dispatch(getLabelOrderProductThunk())
	}, [activeOrder, dispatch])

	return (
		<BikeLabelOrderLayout>
			<BikeLabelOrderStep />
		</BikeLabelOrderLayout>
	)
}

export default BikeLabelOrder
